import axios from 'axios';
import { handleApiAuthError } from './authSession';

// Используем относительный URL для API, чтобы избежать проблем с SSL
// Если REACT_APP_BACKEND_URL не установлен, используем относительный путь
const getApiUrl = () => {
  // В production всегда используем относительный URL
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    // Если URL указан и это localhost, используем его
    if (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
      return envUrl;
    }
    // Для production используем относительный путь, чтобы избежать проблем с SSL
    return '';
  }
  // По умолчанию для development
  return 'http://localhost:8000';
};

const API_URL = getApiUrl();

/**
 * Получить токен авторизации из localStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

/**
 * Создать axios instance с авторизацией.
 * Telemetry Phase 2: добавлен request_id header + network interceptor.
 */
export const getAuthenticatedAxios = () => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const instance = axios.create({
    baseURL: API_URL || '', // Пустая строка означает относительный URL
    headers,
  });

  instance.interceptors.response.use(response => response, error => {
    handleApiAuthError(error);
    return Promise.reject(error);
  });

  // Attach telemetry interceptors (request_id + network event).
  try {
    // Lazy import to avoid circular dep at module load time.
    // Ok to `require` since CRA handles it; if fails — silently skip telemetry.
    // eslint-disable-next-line global-require
    const { newRequestId } = require('./frontLogger');
    instance.interceptors.request.use((cfg) => {
      const rid = newRequestId();
      cfg.headers = { ...(cfg.headers || {}), 'X-Request-ID': rid };
      cfg.metadata = { rid, start: performance.now() };
      return cfg;
    });
    instance.interceptors.response.use(
      (resp) => {
        try {
          // eslint-disable-next-line global-require
          const fl = require('./frontLogger');
          const { rid, start } = resp.config.metadata || {};
          const duration_ms = start ? Math.round(performance.now() - start) : undefined;
          // Log as non-blocking.
          fl.logAction('network', {
            target: resp.config.url,
            extra: {
              request_id: rid,
              method: (resp.config.method || 'get').toUpperCase(),
              status: resp.status,
              duration_ms,
            },
          });
        } catch { /* swallow */ }
        return resp;
      },
      (err) => {
        try {
          // eslint-disable-next-line global-require
          const fl = require('./frontLogger');
          const { rid, start } = err.config?.metadata || {};
          const duration_ms = start ? Math.round(performance.now() - start) : undefined;
          fl.logAction('network', {
            target: err.config?.url,
            extra: {
              request_id: rid,
              method: (err.config?.method || 'get').toUpperCase(),
              status: err.response?.status || 0,
              duration_ms,
              error: (err.message || '').slice(0, 512),
            },
          });
        } catch { /* swallow */ }
        return Promise.reject(err);
      },
    );
  } catch { /* swallow */ }

  return instance;
};

/**
 * Проверить, требуется ли повторная авторизация
 */
export const handleAuthError = (error, toast) => {
  if (error.response?.status === 401) {
    toast?.error('Ошибка авторизации. Пожалуйста, войдите снова.');
    // Можно также перенаправить на страницу логина
    // window.location.href = '/login';
    return true;
  }
  return false;
};

export { API_URL, getApiUrl };

